"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("@coreui/react");
const react_2 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const config_1 = require("config");
const merchant_management_v1_api_1 = require("merchant-management-v1-api");
const utils_1 = require("utils");
const ProgramManagementHeader_1 = __importDefault(require("./ProgramManagementHeader"));
const ACCard_1 = __importDefault(require("./Tabs/ACCard"));
const AccessPrograms_1 = __importDefault(require("./Tabs/AccessPrograms"));
// Selectors
const selectMerchantPortal = (state) => state.root.merchantPortal;
function ProgramManagement() {
    // Ref
    const tabRef = (0, react_2.useRef)(null);
    // Redux Selector
    const { root } = (0, react_redux_1.useSelector)(selectMerchantPortal);
    // Current Location & Permissions
    const { currentLocation } = root;
    const currentPermissions = currentLocation.permissions;
    // State
    const [currentProgramShown, setCurrentProgramShown] = (0, react_2.useState)('ac-card');
    const [skipLenders, setSkipLenders] = (0, react_2.useState)(true);
    const [accessEligible, setAccessEligible] = (0, react_2.useState)(false);
    // Query - Get Feature Flags
    const { data: globalConfig } = (0, merchant_management_v1_api_1.useGetMerchantManagementV1FeatureFlagsGlobalQuery)();
    const { featureFlags } = globalConfig;
    // Query - Get/Skip
    const { data: lenderEligibility } = (0, merchant_management_v1_api_1.useGetMerchantManagementV1LocationsIdEnrollmentLendersQuery)({
        id: currentLocation.locationId,
    }, {
        skip: skipLenders,
    });
    // Effects
    (0, react_2.useEffect)(() => {
        if (lenderEligibility) {
            const lendersArr = Array.from(lenderEligibility);
            if (lendersArr.length && lendersArr[0].name === 'AFF') {
                setAccessEligible(true);
            }
        }
    }, [lenderEligibility]);
    (0, react_2.useEffect)(() => {
        if (currentLocation.locationId) {
            setSkipLenders(false);
        }
    }, [currentLocation]);
    (0, react_2.useEffect)(() => {
        if (currentProgramShown === 'access') {
            if (tabRef.current) {
                tabRef.current.click();
            }
        }
    }, [currentProgramShown]);
    // NO PERMISSIONS
    if ((0, utils_1.operationNotPermitted)(currentPermissions, config_1.PERMISSION.MANAGE_PROGRAMS)) {
        return (0, jsx_runtime_1.jsx)(react_router_dom_1.Redirect, { to: config_1.MERCHANT_PORTAL_URL });
    }
    else {
        // HAS PERMISSIONS
        return ((0, jsx_runtime_1.jsx)("div", { className: "program-management", children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(ProgramManagementHeader_1.default, { setCurrentProgramShown: setCurrentProgramShown, currentLocation: currentLocation }), (0, jsx_runtime_1.jsx)("div", { className: "core-ui", children: (0, jsx_runtime_1.jsxs)(react_1.CTabs, { activeItemKey: currentProgramShown, onChange: (tab) => {
                                setCurrentProgramShown(tab);
                            }, children: [(0, jsx_runtime_1.jsxs)(react_1.CTabList, { variant: "underline-border", children: [(0, jsx_runtime_1.jsx)(react_1.CTab, { "aria-controls": "alphaeon-credit-tab-pane", itemKey: 'ac-card', children: "Alphaeon Credit Card" }), featureFlags?.mfeEnrollments && accessEligible && ((0, jsx_runtime_1.jsx)(react_1.CTab, { "aria-controls": "access-programs-tab-pane", itemKey: 'access', ref: tabRef, children: "Alphaeon Access" }))] }), (0, jsx_runtime_1.jsxs)(react_1.CTabContent, { children: [(0, jsx_runtime_1.jsx)(react_1.CTabPanel, { className: "py-3", "aria-labelledby": "alphaeon-credit-tab-pane", itemKey: 'ac-card', children: (0, jsx_runtime_1.jsx)(ACCard_1.default, { currentLocation: currentLocation }) }), (0, jsx_runtime_1.jsx)(react_1.CTabPanel, { className: "py-3", "aria-labelledby": "access-programs-tab-pane", itemKey: 'access', children: featureFlags?.mfeEnrollments && accessEligible && ((0, jsx_runtime_1.jsx)(AccessPrograms_1.default, { locationId: currentLocation.locationId, isSigner: currentLocation.isCurrentLocationManagerSigner, signers: currentLocation.signers })) })] })] }) })] }) }));
    }
}
exports.default = ProgramManagement;
